import { useNavigate } from 'react-router-dom';
import { startTransition } from 'react';

import Logo from '../Logo/Logo';
import FooterBanner from './FooterBanner';
import Subscribe from './Subscribe';

const Footer = () => {
  const navigate = useNavigate();

  const footerLinks = [
    {
      title: 'Menú',
      links: [
        { href: '/', name: 'Inicio' },
        { href: '/productsLaser', name: 'Corte y grabado Laser' },
        { href: '/products3d', name: 'Impresion 3d' },
        { href: '/productsMates', name: 'Mates y accesorios'},
        { href: '/productsBbq', name: 'Tablas de madera' },
        { href: '/cart', name: 'Carrito' },
        { href: '/contact', name: 'Contacto' }
      ],
    },
    {
      title: 'Contactanos',
    },
  ];

  const handleClick = (link) => {
    startTransition(() => {
      navigate(link);
    });
  };

  return (
    <div>
      <div className="container mb-10">
        <FooterBanner />
      </div>
      <div className="bg-black text-white py-10">
        <div className="container grid gap-10 py-16 lg:grid-cols-2 lg:gap-0">
          <div className="space-y-10 md:pr-20">
            <Logo className="block" />
            <p>Capacut3D fue creado en 2018 con la misión de ofrecer soluciones personalizadas en corte láser e impresión 3D. Nos especializamos en la creación de piezas únicas y productos innovadores para clientes de todo el mundo.</p>
            <Subscribe />
          </div>
          <div className="grid grid-cols-2 gap-5 md:grid-cols-3">
            <div className="space-y-5">
              <h4 className="text-2xl font-medium">
                {footerLinks[0]?.title}
              </h4>
              {footerLinks[0]?.links.map((link) => (
                <div key={link.name} className="cursor-pointer rounded rounded-xl dark2 p-2" onClick={() => handleClick(link.href)}>
                  {link.name}
                </div>
              ))}
            </div>
            <div>
              <div className="grid gap-5">
                {footerLinks.slice(1, 3).map((item) => (
                  <div key={item.title} className="space-y-5">
                    <h4 className="text-2xl font-medium">{item.title}</h4>
                    <div className="flex items-center gap-x-2 cursor-pointer rounded rounded-xl dark2 p-2">
                      <a href={"https://wa.me/5491122867994"} target="_blank" rel="noreferrer">Whatsapp</a>
                    </div>
                    <div className="flex items-center gap-x-2 cursor-pointer rounded rounded-xl dark2 p-2">
                      <a href={"https://www.google.com.ar/maps/place/Rafael+Obligado+1617,+B1655+Jos%C3%A9+Le%C3%B3n+Su%C3%A1rez,+Provincia+de+Buenos+Aires/@-34.510541,-58.5855914,18z/data=!4m6!3m5!1s0x95bcbaf6b2be5c59:0x7613f17a562fb72!8m2!3d-34.5108261!4d-58.5836763!16s%2Fg%2F11cs6n5bzc?hl=es&entry=ttu&g_ep=EgoyMDI1MDQxNC4xIKXMDSoASAFQAw%3D%3D"} target="_blank" rel="noreferrer">Dirección</a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="space-y-5">
              <h4 className="text-2xl font-medium">
                {footerLinks[3]?.title}
              </h4>
              {footerLinks[3]?.links.map((link) => (
                <div key={link.name} onClick={() => handleClick(link.href)}>
                  {link.name}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
